function JobCategoriesDesignIcon({ color = "#191515" }) {
  return (
    <svg
      width="42"
      height="48"
      viewBox="0 0 42 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.0532 52.6757L4.70994 39.4908C2.55502 36.4684 2.42859 32.6919 4.37768 29.5684L20.9576 2.99861L37.6178 29.6458C39.5683 32.7655 39.4474 36.5388 37.2997 39.5615L28.5529 53.2381"
        stroke={color}
        stroke-width="5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M21 3.18103V33.2773"
        stroke={color}
        stroke-width="5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M22.7999 67H19.1999C15.5158 67 12.5293 64.4431 12.5293 61.289V52.4958H29.4705V61.289C29.4705 64.4431 26.484 67 22.7999 67Z"
        stroke={color}
        stroke-width="5"
        stroke-miterlimit="10"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export default JobCategoriesDesignIcon;
